'use client';

import { FontSize } from '@app/domain/model/FontSize';
import { AccessibilityContext } from '@app/app/_context/AccessibilityContext/AccessibilityContext';
import { ReactNode, useEffect, useState } from 'react';

interface Props {
    children: ReactNode;
}

export function AccessibilityProvider({ children }: Props) {
    const [fontSize, setFontSize] = useState<string>(FontSize.Normal);
    const [isHighContrastMode, setIsHighContrastMode] = useState(false);

    useEffect(() => {
        const updateAccessibilitySettings = () => {
            const fontSizeSetting = document.body.getAttribute('data-accessibility-font-size');
            const highContrastMode = document.body.getAttribute('data-accessibility-high-contrast-mode') === 'true';

            setFontSize(fontSizeSetting ?? FontSize.Normal);
            setIsHighContrastMode(highContrastMode);
        };

        updateAccessibilitySettings();

        const observer = new MutationObserver(updateAccessibilitySettings);
        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['data-accessibility-font-size', 'data-accessibility-high-contrast-mode'],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <AccessibilityContext.Provider value={{ fontSize, isHighContrastMode }}>
            {children}
        </AccessibilityContext.Provider>
    );
}
